import React from 'react';

import { ReportingFlow } from '../ReportingFlow';

export const ExplorerPage = () => <ReportingFlow />;
